<template>
  <button disabled class="bx--btn bx--skeleton" :class="{ 'bx--btn--sm': small }" type="button"></button>
</template>

<script>
export default {
  name: 'EbSkeletonButton',
  props: {
    small: { type: Boolean, default: false },
  },
};
</script>
